export const MIOP = {
  VER: 5,

  OP_PING: 0,
  OP_PONG: 1,
  OP_BIND: 2,
  OP_MSG: 3,
  OP_MSGACK: 4,
  OP_UNBIND: 5,
  OP_BINDACK: 6,
  OP_UNBINDACK: 7,
  OP_ALIAS: 17,
};
